import { useEffect, useState } from 'react';
import ProducerContentContainer from '../layout/ProducerContentContainer';
import styles from './ProducerMessagesPage.module.css';
import MessagesView from '../../../shared/messages/MessagesView';
import ReceiveToggle from '../../../shared/messages/ReceiveToggle';
import { getMessageSettings, updateMessageSettings, isMessagingUnavailable } from '../../../api/messageApi';

export default function ProducerMessagesPage() {
  const [allow, setAllow] = useState(null); // null = 아직 모름
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getMessageSettings()
      .then(s => setAllow(Boolean(s.allowIncomingMessages)))
      .catch(err => { if (!isMessagingUnavailable(err)) setAllow(false); });
  }, []);

  const handleToggle = async (next) => {
    if (saving) return;
    const prev = allow;
    setAllow(next);
    setSaving(true);
    try {
      await updateMessageSettings(next);
    } catch {
      setAllow(prev);
      alert('메시지 수신 설정 변경에 실패했습니다.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <ProducerContentContainer>
      <div className={styles.header}>
        <div className={styles.headerInner}>
          <h1 className={styles.pageTitle}>메시지</h1>
          <p className={styles.pageSubtitle}>캐스팅 제안과 대화 내역을 한곳에서 확인하세요.</p>
        </div>
      </div>
      <div className={styles.content}>
        <MessagesView
          headerRight={
            allow != null && (
              <ReceiveToggle checked={allow} busy={saving} onChange={handleToggle} />
            )
          }
        />
      </div>
    </ProducerContentContainer>
  );
}
